import { render, staticRenderFns } from "./VehicleInfoComponent.vue?vue&type=template&id=60c9e1d8"
import script from "./VehicleInfoComponent.vue?vue&type=script&lang=ts"
export * from "./VehicleInfoComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports